import { Loader } from '@googlemaps/js-api-loader';

let googleCached;

export default async () => {
    
    if (googleCached) 
        return googleCached;

    const loader = new Loader({
        apiKey: 'AIzaSyCfEcTP3VdbZLuesGYQLHQFB8c0cYXS7tQ',
        version: 'quarterly',
        libraries: ['marker', 'geometry', 'places']
    });

    await loader.importLibrary('maps');
    await loader.importLibrary('marker');
    await loader.importLibrary('places');
    await loader.importLibrary('geometry');

    googleCached = window.google;

    return googleCached;
};
